import { Landmark, File, Newspaper, DiamondPlus } from "lucide-react";
import { useTranslations } from "next-intl";

// Definición de tipos para mejor organización
export interface NavLink {
  label: string;
  href: string;
}

export interface NavItemDropdown {
  type: "dropdown";
  label: string;
  title: string;
  description: string;
  iconSrc: React.ComponentType<{ className?: string }>;
  linkHref: string;
  titleButton: string;
  links: NavLink[];
}

export type NavItem = NavItemDropdown;

export function useNavItemsCorp(): NavItemDropdown[] {
  const t = useTranslations("navCorp");

  // Items con desplegable
  const dropdownItems: NavItemDropdown[] = [
    {
      type: "dropdown",
      label: t("nosotros.label"),
      title: t("nosotros.title"),
      description: t("nosotros.description"),
      iconSrc: Landmark,
      linkHref: "/corporativo/historia",
      titleButton: t("nosotros.button"),
      links: [
        { label: t("nosotros.historia"), href: "/corporativo/historia" },
        {
          label: t("nosotros.institucional"),
          href: "/corporativo/institucional",
        },
        {
          label: t("nosotros.organizacion"),
          href: "/corporativo/nuestraOrganizacion",
        },
        {
          label: t("nosotros.responsabilidad"),
          href: "/corporativo/responsabilidadSocial",
        },
      ],
    },
    {
      type: "dropdown",
      label: t("gestionPublica.label"),
      title: t("gestionPublica.title"),
      description: t("gestionPublica.description"),
      iconSrc: File,
      linkHref: "/corporativo/transparencia",
      titleButton: t("gestionPublica.button"),
      links: [
        {
          label: t("gestionPublica.concursos"),
          href: "/corporativo/concursosComerciales",
        },
        {
          label: t("gestionPublica.transparencia"),
          href: "/corporativo/transparencia",
        },
        {
          label: t("gestionPublica.informacionFinanciera"),
          href: "/corporativo/transparencia/informacion-financiera",
        },
        { label: t("gestionPublica.memorias"), href: "/corporativo/memorias" },
      ],
    },
    {
      type: "dropdown",
      label: t("servicios.label"),
      title: t("servicios.title"),
      description: t("servicios.description"),
      iconSrc: DiamondPlus,
      linkHref: "/corporativo/sms",
      titleButton: t("servicios.button"),
      links: [
        { label: t("servicios.sms"), href: "/corporativo/sms" },
        // { label: t("servicios.proyectos"), href: "/corporativo/proyectos" },
        { label: t("servicios.sigat"), href: "/corporativo/sigat" },
        { label: t("servicios.fauna"), href: "/corporativo/controlFauna" },
      ],
    },
    {
      type: "dropdown",
      label: t("actualidad.label"),
      title: t("actualidad.title"),
      description: t("actualidad.description"),
      iconSrc: Newspaper,
      linkHref: "/corporativo/noticias",
      titleButton: t("actualidad.button"),
      links: [
        { label: t("actualidad.noticias"), href: "/corporativo/noticias" },
        { label: t("actualidad.directorio"), href: "/corporativo/directorio" },
        {
          label: t("actualidad.publicaciones"),
          href: "/corporativo/publicaciones",
        },
      ],
    },
  ];

  return dropdownItems;
}
